import { render, staticRenderFns } from "./CreateTournament.vue?vue&type=template&id=741999ce&scoped=true&lang=pug"
import script from "./CreateTournament.vue?vue&type=script&lang=js"
export * from "./CreateTournament.vue?vue&type=script&lang=js"
import style0 from "./CreateTournament.vue?vue&type=style&index=0&id=741999ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741999ce",
  null
  
)

export default component.exports